import React from "react";

import { numberWithCommas } from "lib/utils";

const BuyInfo = ({ type, currentPrice }) => {
  let upperType = "";
  let titClass = "";
  let titTxt = "";
  if (type) {
    if (type === "peg") {
      titClass = "e_gold";
      titTxt = "E금";
      upperType = "Peg";
    } else if (type === "pes") {
      titClass = "e_silver";
      titTxt = "E은";
      upperType = "Pes";
    } else {
      // window.wallet.finish(); // 비단 앱 종료
    }
  }

  const price = currentPrice[`${type}Price`];
  const diffPrice = currentPrice[`diff${upperType}Price`];

  let priceOp = "";
  let priceClass = "plus";
  let rateOp = "";
  let priceRate = ((diffPrice / price) * 100).toFixed(2);

  if (diffPrice > 0) {
    priceOp = "▲";
  } else if (diffPrice < 0) {
    priceOp = "▼";
    priceClass = "minus";
  }

  if (priceRate > 0) {
    rateOp = "+";
  } else if (priceRate < 0) {
    rateOp = "-";
  }

  return (
    <div className="section bg_blue">
      <div className="content">
        <h3 className="img_tit">
          <div className={titClass}>{titTxt}</div>{" "}
        </h3>
        <div className="my_money">
          <p className="tt2">
            {numberWithCommas(price)} <span className="krw">KRW</span>
          </p>
          <p className="tt3">
            전일대비{" "}
            <span className={`per ${priceClass}`}>
              {rateOp}
              {Math.abs(priceRate)}% {priceOp}{" "}
              {!!diffPrice && numberWithCommas(diffPrice)}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default BuyInfo;
